import { eventEmitter } from "@/utils/event-emitter.js";
import { appState } from "@/utils/state.js";
import { getLS } from "@/utils/local-storage.js";

export function continueGame() {
  eventEmitter.on("continueGame", () => {
    const gameData = getLS("savedGame");
    appState.setAllState(gameData);
    console.log(appState.getAllState());
    eventEmitter.emit("levelChange");
    eventEmitter.emit("templateChange");
    const boardArr = document.querySelectorAll(".cell");
    const userInput = gameData.userInput;
    userInput.forEach((elem, i) => {
      if (elem === 1) {
        boardArr[i].classList.add("dark");
      }
      if (elem === 2) {
        boardArr[i].classList.add("x");
      }
    });
  });
}
